import React from "react";
import Slider from "react-slick";
import NumberFormat from "react-number-format";

const InfoSlider = ({ stats }) => {
  const [currency] = React.useState("NGN");

  let settings = {
    dots: false,
    infinite: stats?.length > 4,
    speed: 500,
    slidesToShow: 1.5,
    slidesToScroll: 1,
    initialSlide: 0,
    swipeToSlide: true,
    draggable: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1,
          infinite: stats?.length > 2,
          dots: false,
          centerMode: true,
          focusOnSelect: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1,
          initialSlide: 1,
          centerMode: true,
          focusOnSelect: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          focusOnSelect: true,
        },
      },
    ],
  };

  if (!stats || stats.length === 0) return null;

  return (
    <div className="main_container_inner_div pb-0">
      <div className="profile_container">
        <div className="slider_div_to_top">
          <Slider {...settings}>
            {stats.map((stat, index) => (
              <div
                key={index}
                className={`item grid-4-box colored ${stat.color || "color_1"} loyalty_card`}
              >
                <div className="slick-div">
                  <div className="slick-box">
                    <div className="icon-box">
                      <img src={stat.icon} alt={stat.title} />
                    </div>
                    <div className="slider-main-content">
                      <p>{stat.title} {stat.isCurrency ? currency : ""}</p>
                      <h2>
                        {stat.isCurrency && (
                          <span style={{ marginRight: "3px" }} className="currency">
                            ₦
                          </span>
                        )}
                        <NumberFormat
                          thousandSeparator={true}
                          displayType={"text"}
                          value={stat.value ?? 0}
                        />
                      </h2>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default InfoSlider;
